import { useEffect, useState } from 'react';

function preloadImage(src = '') {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
            resolve(img);
        };
        img.onerror = img.onabort = function () {
            var preloadLink = document.createElement('link');
            preloadLink.href = src;
            preloadLink.rel = 'preload';
            preloadLink.as = 'image';
            document.head.appendChild(preloadLink);
            resolve('success');
        };
        img.src = src;
    });
}

export default function useImagePreloader(imageList = []) {
    const [isPreloaded, setIsPreloaded] = useState(false);

    useEffect(() => {
        let isCancelled = false;

        async function effect() {
            if (isCancelled) {
                return;
            }

            const res = await Promise.all(imageList.map((src) => preloadImage(src)));
            console.log(res);
            if (isCancelled) {
                return;
            }

            setIsPreloaded(true);
        }

        effect();

        return () => {
            isCancelled = true;
        };
    }, [imageList]);

    return { isPreloaded };
}
